export default "/assets/eye-bf24c2657a8b6abfec60446a18f858e086c8f8a25351142f64a77a4e51079ee3.svg";